import { MediaGalleryInterface } from '@pylot-data/fwrdschema'

export const getMediaGalleryWithParentProduct = (
    selectedGallery: MediaGalleryInterface[],
    galleryEntries: MediaGalleryInterface[]
) => {
    return [
        ...(selectedGallery ?? []).map((i) => ({
            ...i,
            position: (i?.position ?? 0) - 50
        })),
        ...galleryEntries
    ]
}
